<app-content-area
  [title]="title | translate"
  [actions]="contentAreaActions"
  (emitterEventActionClick)="handleContentAreaEvent($event)"
>
  <app-form-area
    [showButtons]="buttonsEmployeeForm"
    [formGroup]="form"
    (emitterEventActionClick)="handleFormAreaEvent($event)"
  >
    <h4> {{ 'EMPLOYEE_FORM.FORM.EMPLOYEE_DATA' | translate }}</h4>
    <app-input
      type="text"
      [label]="'EMPLOYEE_FORM.FORM.DOCUMENT' | translate"
      [placeholder]="'EMPLOYEE_FORM.FORM.DOCUMENT_PLACEHOLDER' | translate"
      [control]="form.get('document')"
      mask="cpf"
    />
    <app-input
      type="text"
      [label]="'EMPLOYEE_FORM.FORM.NAME' | translate"
      [placeholder]="'EMPLOYEE_FORM.FORM.NAME_PLACEHOLDER' | translate"
      [control]="form.get('name')"
    />
    <div class="slide-toggle-container">
      <mat-slide-toggle
        labelPosition="before"
        [checked]="form.get('status')?.value === true"
        (change)="form.get('status')?.setValue($event.checked)"
        color="primary"
      >
        {{ 'PEOPLE_FORM.FORM.PEOPLE_DATA.STATUS' | translate }}
      </mat-slide-toggle>
    </div>
    <app-card-area
      [title]="'EMPLOYEE_FORM.FORM.EMAIL.TITLE' | translate"
      (emitterEvent)="addEmail()"
      [buttonLabel]="'EMPLOYEE_FORM.FORM.EMAIL.ADD_BUTTON' | translate"
    >
      @for (emailCtrl of emails.controls; track $index) {
        <app-email-card
          [control]="emailCtrl"
          [index]="$index"
          (remove)="removeEmail($index)"
          [totalItems]="emails.length"
        />
      }
    </app-card-area>
    <app-card-area
      [title]="'EMPLOYEE_FORM.FORM.ADDRESSES.TITLE' | translate"
      (emitterEvent)="addAddress()"
      [buttonLabel]="'EMPLOYEE_FORM.FORM.ADDRESSES.ADD_BUTTON' | translate"
    >
      @for (addressCtrl of addresses.controls; track $index) {
        <app-address-card
          [control]="addressCtrl"
          [index]="$index"
          (remove)="removeAddress($index)"
          [totalItems]="addresses.length"
        />
      }
    </app-card-area>
  </app-form-area>
</app-content-area>
